import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_info",
  "use": "icon_info-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_info\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23 16a5 5 0 100-10 5 5 0 000 10zm-1.875 20h-1.563C18.7 36 18 36.7 18 37.563v2.874c0 .864.7 1.563 1.563 1.563H29.5c.863 0 1.563-.7 1.563-1.563v-2.874c0-.864-.7-1.563-1.563-1.563h-1.438V19.562c0-.863-.699-1.562-1.562-1.562h-6.938C18.7 18 18 18.7 18 19.563v2.875C18 23.3 18.7 24 19.563 24h1.562v12z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol